import { useEffect } from "react"
import { capturePostHogEvent } from "@/lib/posthog"

/**
 * Fires `job_page_viewed` once the public job detail has loaded.
 * Covers every job at `/jobs/$jobId` (existing and newly posted).
 */
export function useTrackJobPageView(args: {
  jobId: string | null
  title: string | null | undefined
  companyId?: string | null
  companyName?: string | null
}) {
  const { jobId, title, companyId, companyName } = args

  useEffect(() => {
    if (!jobId || !title) return
    capturePostHogEvent("job_page_viewed", {
      job_id: jobId,
      job_title: title,
      company_id: companyId ?? null,
      company_name: companyName ?? null,
    })
  }, [jobId, title, companyId, companyName])
}
